import { SharedUserGuard } from '@agroone-front/shared'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UserGuard extends SharedUserGuard {}
